<template>
	<div class="wrap search-all-wrap flex-column">
		<topLink></topLink>
		<!-- 搜索框 -->
		<div class="input-box">
			<input v-model="searchKey" class="serarch-input" type="text" name="" placeholder="搜索商品关键词">
			<span class="search-btn" @click="searchGoods(searchKey)">搜索</span>
		</div>
		<div class="flex-item">
			<div class="last-search" v-if="lastSearchList && lastSearchList.length">
				<div class="header">
					<span class="floatL">最近搜索</span>
					<span class="floatR button" @click="isDialog=true">清除</span>
					<div class="clearfix"></div>
				</div>
				<div class="search-label">
					<mu-flat-button :label="item" class="label" :key="index" v-for="item,index in lastSearchList" @click="searchGoods(item)"/>
				</div>
			</div>
			<div class="hot-search" v-if="searchKeywordList && searchKeywordList.length">
				<div class="header">
					<span class="floatL">热门搜索</span>
					<span class="floatR button" @click="batchKeyword">换一批</span>
					<div class="clearfix"></div>
				</div>
				<div class="search-label">
					<mu-flat-button @click="searchGoods(item)" :label="item" :key="index" class="label" v-for="item,index in searchKeywordList"/>
				</div>
			</div>
		</div>
		<mu-dialog :open="isDialog" title="提示" @close="isDialog=false">
		    是否清空搜索内容
		    <mu-flat-button slot="actions" @click="isDialog=false" primary label="取消"/>
		    <mu-flat-button slot="actions" primary @click="clearSearch" label="确定"/>
		</mu-dialog>
	</div>
</template>
<script type="text/javascript">
	import imgs from '@components/image/image';
	import topLink from '@components/topLink/topLink';
	import { mapActions, mapGetters } from 'vuex';
	export default{
		data(){
			return {
				isDialog: false,
				searchKey: null,
			}
		},
		computed:{
		    ...mapGetters({
		      	searchKeywordList: 'searchKeywordList',//随机搜索词列表
		      	lastSearchList: 'lastSearchList',//最近搜索关键词
		    })
		},
		created(){
			this._initView();
		},
		methods:{
			...mapActions({
      			getHotSearch: 'getHotSearch',//随机获取一组关键词
      			addLastSearch: 'addLastSearch',//添加最近搜索关键词
      			clearLastSearch: 'clearLastSearch',//清空最近搜索关键词
			}),
			_initView(){
				//随机获取搜索词列表
			    if(!this.searchKeywordList || !this.searchKeywordList.length){
			        this.getHotSearch();
			    }
			},
			//换一批关键词
			batchKeyword(){
				this.getHotSearch();
			},

			//搜索商品
			searchGoods(keyword){
				if(!keyword || !keyword.trim()){
					return;
				}
				this.addLastSearch(keyword);
				this.$router.push({
					path: '/main/search',
					query: {
						keyWord: keyword
					}
				})
			},

			//清空最近搜索
			clearSearch(){
				this.isDialog = false;
				this.clearLastSearch();
			}
		},
		components:{
			topLink,
			imgs
		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.search-all-wrap{
		.input-box{
			width: 100%;
			padding: 0.1rem 0;
			background: #fff;
			box-shadow: 0 1px 2px 0 rgba(0,0,0,0.09);
			z-index: 2;
			text-align: center;
			.serarch-input{
				display: inline-block;
				width: 75%;
				height: 0.7rem;
				margin: 0 auto;
				border-radius: 0.675rem;
				@include sInput(#EFEFEF,center,#999999);
				background: url(/static/images/productList_search@3x.png) no-repeat 0.25rem center;
				background-size: 0.45rem;
				background-color: #EFEFEF;
			}
			.search-btn{
				display: inline-block;
				margin-left: 0.25rem;
				@include font-dpr(14px);
				color: #666666;
			}
		}
		.flex-item{
			background: #fff;
			.search-label{
				font-size: 0;
			}
			.hot-search,.last-search{
				padding-left: 0.275rem;
				@include font-dpr(12px);
				color: #323232;
				.header{
					padding: 0.4rem 0;
				}
				.button{
					padding-right: 0.275rem;
					color: #4A90E2;
				}
				.mu-flat-button-label{
					@include font-dpr(12px);
				}
				.label{
					background: #F6F6F6;
					border: 1px solid #E1E1E1;
					height: auto;
					min-width: 1.5rem;
					line-height: inherit;
					margin: 0 0.35rem 0.3rem 0;
					.mu-flat-button-label{
						margin: 0.175rem;
						padding: 0;
						line-height: 1;
					}
				}
			}
			.last-search{
				border-bottom: 1px solid #E5E5E5;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// allSearch.vue?0d2db883